import React from "react";
import { DataBox } from "./DataBox";
import { useFullOrderModel, FullOrderEnum } from "../fullOrderModel"
import { BusSearchBox } from "./BusSearchBox"
import { PurchaseSearchBox } from "./PurchaseSearchBox"
import { RepairSearchBox } from "./RepairSearchBox"
import { SaleSearchBox } from "./SaleSearchBox"
export function FullOrder() {
    const DetailSearchBox = () => {
        const { fullOrderStatus } = useFullOrderModel();
        switch (fullOrderStatus) {
            case FullOrderEnum.purchase:
                return <PurchaseSearchBox />;
            case FullOrderEnum.sale:
                return <SaleSearchBox />;
            case FullOrderEnum.repair:
                return <RepairSearchBox />;
            case FullOrderEnum.ciRepair:
                return <RepairSearchBox />;
            case FullOrderEnum.bus:
                return <BusSearchBox />;
            default:
                return <></>
        }
    }
    return (
        <>
            <DetailSearchBox />
            <DataBox />
        </>
    )
}